<app-leveltwo [pageName]="'General Info'">
<div class="General">
  <h3>{{'Prop13.SearchTitle'|translate}}</h3>

      <p>{{'Prop13.Thediscovery'|translate}}</p>
      <p>{{'Prop13.Assessing2'|translate}}</p>
      <p>{{'Prop13.in1978'|translate}}</p>
      <p>{{'Prop13.Inaddition'|translate}}</p>
      <p>{{'Prop13.Priorto'|translate}}</p>
      <p>{{'Prop13.Foranexplanation'|translate}} <a href="https://propertytax.lacounty.gov/Home/AnnualSecuredProperty" target="_blank">propertytax.lacounty.gov/Home/AnnualSecuredProperty</a></p>


</div>
</app-leveltwo >
